/* Halvari collection page: submit the sort form as soon as the menu changes.
   Without JavaScript the form shows an "Apply" button instead. */
(function () {
  'use strict';

  if (window.__halvariCollectionInit) return;
  window.__halvariCollectionInit = true;

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-sort-select]')) return;
    var form = target.form || (target.closest ? target.closest('form') : null);
    if (form) form.submit();
  });
})();
